var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.lastPage > 1
    ? _c(
        "nav",
        {
          class: _vm.classes,
          attrs: { "aria-label": "Pagination Navigation" }
        },
        [
          _c(
            "ul",
            { class: _vm.mdsNS("pagination") },
            [
              _vm.showFirstAndLast
                ? _c("li", { class: _vm.mdsNS("pagination__item") }, [
                    _c(
                      "a",
                      {
                        class: [
                          _vm.mdsNS("pagination__link"),
                          _vm.getDisabledClass(_vm.previousDisabled)
                        ],
                        attrs: {
                          href: "javascript:void(0)",
                          "aria-label": _vm.firstAriaLabel,
                          role: "button",
                          "aria-disabled": "true",
                          tabindex: _vm.previousDisabled ? -1 : 0
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.gotoFirstPage($event)
                          },
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.gotoFirstPage($event)
                          }
                        }
                      },
                      [
                        _vm.showIcon
                          ? _c(
                              "svg",
                              {
                                class: _vm.mdsNS("icon pagination__icon"),
                                attrs: { "aria-hidden": "true" }
                              },
                              [
                                _c("use", {
                                  attrs: {
                                    "xlink:href": "#angle-double-left--s"
                                  }
                                })
                              ]
                            )
                          : _vm._e(),
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.showText ? _vm.firstLabel : "") +
                            "\n            "
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showPreviousNext
                ? _c("li", { class: _vm.mdsNS("pagination__item") }, [
                    _c(
                      "a",
                      {
                        class: [
                          _vm.mdsNS("pagination__link"),
                          _vm.getDisabledClass(_vm.previousDisabled)
                        ],
                        attrs: {
                          href: "javascript:void(0)",
                          "aria-label": _vm.previousAriaLabel,
                          role: "button",
                          "aria-disabled": "true",
                          tabindex: _vm.previousDisabled ? -1 : 0
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.gotoPreviousPage($event)
                          },
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.gotoPreviousPage($event)
                          }
                        }
                      },
                      [
                        _vm.showIcon
                          ? _c(
                              "svg",
                              {
                                class: _vm.mdsNS("icon pagination__icon"),
                                attrs: { "aria-hidden": "true" }
                              },
                              [
                                _c("use", {
                                  attrs: { "xlink:href": "#angle-left--s" }
                                })
                              ]
                            )
                          : _vm._e(),
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.showText ? _vm.previousLabel : "") +
                            "\n            "
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.pages, function(page) {
                return _c(
                  "li",
                  { key: page.id, class: _vm.mdsNS("pagination__item") },
                  [
                    _c(
                      "a",
                      {
                        class: page.classes,
                        attrs: {
                          href: "javascript:void(0)",
                          role: "button",
                          "aria-label": page.ariaLabel,
                          "aria-current": page.ariaCurrent
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.gotoPage(page)
                          },
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.gotoPage(page)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(page.id) +
                            "\n            "
                        )
                      ]
                    )
                  ]
                )
              }),
              _vm._v(" "),
              _vm.showPreviousNext
                ? _c("li", { class: _vm.mdsNS("pagination__item") }, [
                    _c(
                      "a",
                      {
                        class: [
                          _vm.mdsNS("pagination__link"),
                          _vm.getDisabledClass(_vm.nextDisabled)
                        ],
                        attrs: {
                          href: "javascript:void(0)",
                          role: "button",
                          "aria-label": _vm.nextAriaLabel,
                          tabindex: _vm.nextDisabled ? -1 : 0
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.gotoNextPage($event)
                          },
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.gotoNextPage($event)
                          }
                        }
                      },
                      [
                        _vm.showIcon
                          ? _c(
                              "svg",
                              {
                                class: _vm.mdsNS("icon pagination__icon"),
                                attrs: { "aria-hidden": "true" }
                              },
                              [
                                _c("use", {
                                  attrs: { "xlink:href": "#angle-right--s" }
                                })
                              ]
                            )
                          : _vm._e(),
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.showText ? _vm.nextLabel : "") +
                            "\n            "
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showFirstAndLast
                ? _c("li", { class: _vm.mdsNS("pagination__item") }, [
                    _c(
                      "a",
                      {
                        class: [
                          _vm.mdsNS("pagination__link"),
                          _vm.getDisabledClass(_vm.nextDisabled)
                        ],
                        attrs: {
                          href: "javascript:void(0)",
                          role: "button",
                          "aria-label": _vm.lastAriaLabel,
                          tabindex: _vm.nextDisabled ? -1 : 0
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.gotoLastPage($event)
                          },
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.gotoLastPage($event)
                          }
                        }
                      },
                      [
                        _vm.showIcon
                          ? _c(
                              "svg",
                              {
                                class: _vm.mdsNS("icon pagination__icon"),
                                attrs: { "aria-hidden": "true" }
                              },
                              [
                                _c("use", {
                                  attrs: {
                                    "xlink:href": "#angle-double-right--s"
                                  }
                                })
                              ]
                            )
                          : _vm._e(),
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.showText ? _vm.lastLabel : "") +
                            "\n            "
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ],
            2
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }